const actionTypes = { 
  SET_SEARCH_QUERY: 'SET_SEARCH_QUERY'
}

export default actionTypes;